import type { TRootState } from 'store';
import type { ISelector } from 'interfaces/Selector.interface';
import { createSelectorSlice } from 'redux/collections/helper/createSelector.slice';
import {
  currentPageDefault,
  itemsPerPageDefault,
} from 'redux/collections/consts/selectorDefaults.consts';

export const contactDocumentsSlice = createSelectorSlice(
  'paginatedContactDocuments',
  currentPageDefault,
  itemsPerPageDefault,
  { columnKey: 'createdAt', direction: 'desc' }
);

const { actions, reducer } = contactDocumentsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
} = actions;

export const paginatedContactDocumentsSelector = (
  state: TRootState
): ISelector => state.collectionContactDocuments;

export default reducer;
